export default { //一些奇葩需求
    namespaced:true,
    state:{
        diagnosticindex:0, //诊断报告页面刷新   
    },
    mutations:{
        setdiager(state,keywod){
         state.diagnosticindex++
      
        },
        
    }
}